import { useTooltipTracking } from "../../../hooks/useTooltipTracking";
import { Tooltip, TooltipTrigger, TooltipContent } from "../../ui/tooltip";
import { Info } from "lucide-react";

export const InfoTip = ({ id, text }: { id: string; text: string }) => {
    const onOpenChange = useTooltipTracking(id);
    return (
        <Tooltip onOpenChange={onOpenChange}>
            <TooltipTrigger>
                <Info className="h-3.5 w-3.5 text-muted-foreground" aria-hidden="true" />
            </TooltipTrigger>
            <TooltipContent side="top" className="max-w-xs text-zinc-900">
                <p className="font-medium">{text}</p>
            </TooltipContent>
        </Tooltip>
    );
};